module.exports = __webpack_public_path__ + "src/assets/fonts/glyphicons-halflings-regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.woff2
// module id = 32
// module chunks = 0